import { handleActions } from 'redux-actions';
import * as ACTION_TYPES from '../actions/calendarsActionTypes';

const initialState = {
    isLoading: false,
    calendarTypes: [],
    twoUpSectionData: [],
    marqueeSidePanelData: {},
    standaloneContents: [],
    calendarTypesSectionHeadings: {}
};

export default handleActions({
    [ACTION_TYPES.IS_LOADING]: (state, action) => ({
        ...state,
        isLoading: action.payload
    }),
    [ACTION_TYPES.UPDATE_CALENDAR_TYPES]: (state, action)  => {
        const currentCalendarTypes = state.calendarTypes;
        currentCalendarTypes.push(...action.payload);

        return {
            ...state,
            calendarTypes: currentCalendarTypes
        };
    },
    [ACTION_TYPES.UPDATE_MARQUEE_SIDE_PANEL_DETAILS]: (state, action) => ({
        ...state,
        marqueeSidePanelData: action.payload
    }),
    [ACTION_TYPES.UPDATE_TWO_UP_SECTION]: (state, action) => ({
        ...state,
        twoUpSectionData: action.payload
    }),
    [ACTION_TYPES.UPDATE_STANDALONE_CONTENTS]: (state, action) => ({
        ...state,
        standaloneContents: action.payload
    }),
    [ACTION_TYPES.UPDATE_CALENDAR_TYPES_SECTION_HEADINGS]: (state, action) => ({
        ...state,
        calendarTypesSectionHeadings: action.payload
    })
}, initialState);
